import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import m from './messages';

export function SurnameLettersBoard({ active, letters: levelsLetters }) {
  if (!levelsLetters.length) return null;

  return (
    <div className="surname-letters">
      <h3 className="surname-letters__title"><FormattedMessage {...m.surnames} /></h3>
      <p className="surname-letters__desc">
        <FormattedHTMLMessage {...m.tipSurnames} />
      </p>
      <ul className="surname-letters__list">
        { levelsLetters.map((levelLetters, index) => (
          <li className="surname-letters__item" key={index} style={{ paddingLeft: `${index * 10}px` }}>
            { getLettersLink(active, levelLetters) }
          </li>
        ))}
      </ul>
    </div>
  );
}

function getLettersLink(activeLetters, levelLetters) {
  const getClassName = letter => {
    const classValue = 'surname-letters__link';
    if (activeLetters.includes(letter)) return `${classValue} ${classValue}--active`;
    return classValue;
  };

  return levelLetters.map(letter => (
    <Link
      className={getClassName(letter)}
      key={letter}
      to={`?sname=${letter}`}
    >
      {letter }
    </Link>
  ));
}

SurnameLettersBoard.defaultProps = {
  active: [],
  levelsLetters: []
};

export default SurnameLettersBoard;
